/*
 * "In the beginning was the Word, and the Word was with God, and the Word was God."
 *                                                                       — John 1:1
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import { AuthProvider } from './lib/auth.js';
import { trpc, trpcClient, queryClient } from './lib/trpc.js';
import { LogDeliverableProvider } from './contexts/LogDeliverableContext.js';
import { ToastProvider } from './lib/toast.js';
import './index.css';

// When a deploy activates a new service worker (skipWaiting + clientsClaim in
// sw.ts), reload once so this page doesn't keep lazy-loading chunks from the
// previous build that the server no longer has. The controller-existed guard
// keeps the very first SW installation from reloading the page.
if ('serviceWorker' in navigator) {
  let hadController = navigator.serviceWorker.controller !== null;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) window.location.reload();
    hadController = true;
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <BrowserRouter>
              <LogDeliverableProvider>
                <App />
              </LogDeliverableProvider>
            </BrowserRouter>
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </trpc.Provider>
  </React.StrictMode>,
);
